/* eslint-disable */ import { memoEval, sceneEntityObjectPropertiesComponent, sceneEntityRemoteObjectComponent } from '@salsita-ai/platform-project-sdk/domain';
import { attachComponent } from '../implementation.js';
export const threeDrawerBaseComponents = [
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'body', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_LYNX_2DDH_PO_FDH_3D_BODY',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerOne', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerOneHandle', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerTwo', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerTwoHandle', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerThree', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_FRONT_PANEL',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityRemoteObjectComponent, 'drawerThreeHandle', true).withEntity('ThreeDrawerBase').attach(memoEval(()=>[], ()=>({
            fileUrl: '/models/jms.glb',
            objectName: 'CABINET_HANDLE',
            dimensionUnit: 'inch'
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'body', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$width
        ], ($width)=>({
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: 12 * 25.4,
                    scaleOne: 24 * 25.4
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerOne', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerOffsetX,
            self.$drawerOneOffsetY,
            self.$width,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$drawerHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($drawerOffsetX, $drawerOneOffsetY, $width, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $drawerHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $drawerOffsetX,
            offsetY: $drawerOneOffsetY,
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $drawerHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerOneHandle', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerHandleOffsetX,
            self.$drawerOneHandleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($drawerHandleOffsetX, $drawerOneHandleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $drawerHandleOffsetX,
            offsetY: $drawerOneHandleOffsetY,
            offsetZ: $handleOffsetZ,
            rotationZ: Math.PI / 2,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerTwo', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerOffsetX,
            self.$drawerTwoOffsetY,
            self.$width,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$drawerHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($drawerOffsetX, $drawerTwoOffsetY, $width, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $drawerHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $drawerOffsetX,
            offsetY: $drawerTwoOffsetY,
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $drawerHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerTwoHandle', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerHandleOffsetX,
            self.$drawerTwoHandleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($drawerHandleOffsetX, $drawerTwoHandleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $drawerHandleOffsetX,
            offsetY: $drawerTwoHandleOffsetY,
            offsetZ: $handleOffsetZ,
            rotationZ: Math.PI / 2,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerThree', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerOffsetX,
            self.$drawerThreeOffsetY,
            self.$width,
            self.$doorModelWidthScaleZero,
            self.$doorModelWidthScaleOne,
            self.$drawerHeight,
            self.$doorModelHeightScaleZero,
            self.$doorModelHeightScaleOne
        ], ($drawerOffsetX, $drawerThreeOffsetY, $width, $doorModelWidthScaleZero, $doorModelWidthScaleOne, $drawerHeight, $doorModelHeightScaleZero, $doorModelHeightScaleOne)=>({
            offsetX: $drawerOffsetX,
            offsetY: $drawerThreeOffsetY,
            morphTargetInfluences: {
                Width: {
                    value: $width,
                    scaleZero: $doorModelWidthScaleZero,
                    scaleOne: $doorModelWidthScaleOne
                },
                Length: {
                    value: $drawerHeight,
                    scaleZero: $doorModelHeightScaleZero,
                    scaleOne: $doorModelHeightScaleOne
                }
            }
        }))),
    attachComponent.withComponent(sceneEntityObjectPropertiesComponent, 'drawerThreeHandle', true).withEntity('ThreeDrawerBase').attach(memoEval((self)=>[
            self.$drawerHandleOffsetX,
            self.$drawerThreeHandleOffsetY,
            self.$handleOffsetZ,
            self.$handleLength,
            self.$handleModelScaleZero,
            self.$handleModelScaleOne
        ], ($drawerHandleOffsetX, $drawerThreeHandleOffsetY, $handleOffsetZ, $handleLength, $handleModelScaleZero, $handleModelScaleOne)=>({
            offsetX: $drawerHandleOffsetX,
            offsetY: $drawerThreeHandleOffsetY,
            offsetZ: $handleOffsetZ,
            rotationZ: Math.PI / 2,
            morphTargetInfluences: {
                Length: {
                    value: $handleLength,
                    scaleZero: $handleModelScaleZero,
                    scaleOne: $handleModelScaleOne
                }
            }
        })))
];

//# sourceMappingURL=three-drawer-base.js.map